import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import {
  FaTachometerAlt,
  FaUser,
  FaClipboardList,
  FaTasks,
  FaFileAlt,
  FaBoxes,
  FaMoneyCheckAlt,
  FaMoneyBillWave,
  FaUserTie,
  FaUserClock,
  FaCalendarAlt,
  FaChevronDown,
  FaChevronUp
} from 'react-icons/fa';
import { GrUserManager } from 'react-icons/gr';
import { IoClose, IoMenu } from 'react-icons/io5';
import Logo from '../Assets/sdspc-logo.png';
import axios from "axios";

const Sidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  isMobileOpen,
  setIsMobileOpen,
  isMobileView,
  closeMobileSidebar
}) => {
  const navigate = useNavigate();
  const [reportsOpen, setReportsOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [permissions, setPermissions] = useState({});

  const handleToggle = () => {
    if (isMobileView) {
      setIsMobileOpen(prev => !prev);
    } else {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleLogoClick = () => {
    navigate('/home');
    if (isMobileView) closeMobileSidebar();
  };

  const handleLinkClick = () => {
    if (isMobileView) closeMobileSidebar();
  };

  const toggleReports = () => {
    setReportsOpen(prev => !prev);
  };
  const toggleMaster = () => {
    setMasterOpen(prev => !prev);
  };

  // per request: do NOT auto-close the reports submenu after navigation
  const handleReportNav = () => {
    if (isMobileView) {
      // if you prefer closing the mobile overlay on navigation, uncomment below
      // closeMobileSidebar();
    }
  };

  useEffect(() => {
    let userId = localStorage.getItem("user_id");
    console.log("from side bar", userId);
    if (!userId) {
      console.error("No user ID found. Please log in again.");
      return;
    }

    userId = userId.replace(/^"|"$/g, ''); // Remove extra double quotes if they exist

    const fetchPermissions = async () => {
      try {
        console.log("Sending API request with user_id:", userId);

        const response = await axios.post(`${API_BASE_URL}employee_login_previllage.php`,
          { user_id: userId }, // Ensure correct format
          {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
          }
        );

        console.log("API Fixed Response:", response.data);

        if (response.data.head.code === 200 && response.data.body.length > 0) {
          setPermissions(response.data.body[0]);
        } else {
          alert("Error : Previlage Error");
        }
      } catch (error) {
        alert("API Error: Unable to fetch permissions.");
        console.error("API Error:", error);
      }
    };

    fetchPermissions();
  }, []);

  return (
    <>
      {isMobileView && !isMobileOpen && !isSidebarOpen && (
        <button
          className="floating-toggle"
          onClick={() => setIsMobileOpen(true)}
          aria-label="Open sidebar"
        >
          <IoMenu size={22} />
        </button>
      )}

      {isMobileView && isMobileOpen && <div className="overlay" onClick={closeMobileSidebar} />}

      <aside
        className={`sidebar ${isMobileView ? (isMobileOpen ? 'show' : 'hidden') : (isSidebarOpen ? 'show' : 'collapsed')
          }`}
      >
        <div className="sidebar-logo">
          {!isMobileView && isSidebarOpen && (
            <img
              className="img"
              src={Logo}
              alt="Logo"
              style={{ cursor: 'pointer' }}
              onClick={handleLogoClick}
            />
          )}

          <button
            className="toggle-btn"
            onClick={handleToggle}
            aria-label="Toggle sidebar"
          >
            {isMobileView ? (isMobileOpen ? <IoClose size={22} /> : <IoMenu size={22} />)
              : (isSidebarOpen ? <IoClose size={22} /> : <IoMenu size={22} />)}
          </button>
        </div>

        <ul className="sidebar-menu">
          <li>
            <NavLink to="/home" onClick={handleLinkClick}>
              <FaTachometerAlt className="icon" /><span>Dashboard</span>
            </NavLink>
          </li>
          <li className={`sidebar-item-dropdown ${masterOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleMaster}
              aria-expanded={masterOpen}
              aria-controls="reports-submenu"
            >
              <div className="left">
                <FaMoneyCheckAlt className="icon" />
                <span>Master</span>
              </div>
              <div className="caret">
                {masterOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="reports-submenu" className="submenu" aria-hidden={!masterOpen}>

                <li>
                  <NavLink to="/taskThemeList" onClick={handleLinkClick} className="submenu-link">
                    <FaMoneyCheckAlt className="icon-sub" /> <span>Task Theme</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/taskTitleList" onClick={handleLinkClick} className="submenu-link">
                    <FaMoneyBillWave className="icon-sub" /> <span>Task Title</span>
                  </NavLink>
                </li>
            </ul>
          </li>
          {permissions.user === "1" && (
            <li>
              <NavLink to="/userlist" onClick={handleLinkClick}>
                <FaUser className="icon" /><span>Users</span>
              </NavLink>
            </li>
          )}
          {permissions.department === "1" && (
            <li>
              <NavLink to="/departmentList" onClick={handleLinkClick}>
                <GrUserManager className="icon" /><span>Department</span>
              </NavLink>
            </li>
          )}
          {permissions.designation === "1" && (
            <li>
              <NavLink to="/designationlist" onClick={handleLinkClick}>
                <FaUserTie className="icon" /><span>Designation</span>
              </NavLink>
            </li>
          )}
          {permissions.working_hrs === "1" && (
            <li>
              <NavLink to="/workinghours" onClick={handleLinkClick}>
                <FaUserClock className="icon" /><span>Working Hours</span>
              </NavLink>
            </li>
          )}
          {permissions.attendance === "1" && (
            <li>
              <NavLink to="/staffattendance" onClick={handleLinkClick}>
                <FaCalendarAlt className="icon" /><span>Staff Attendance</span>
              </NavLink>
            </li>
          )}
          {permissions.leave_permission === "1" && (
            <li>
              <NavLink to="/permissionleavelist" onClick={handleLinkClick}>
                <FaClipboardList className="icon" /><span>Permission / Leave</span>
              </NavLink>
            </li>
          )}
          {permissions.task === "1" && (
            <li>
              <NavLink to="/task" onClick={handleLinkClick}>
                <FaTasks className="icon" /><span>Create Task</span>
              </NavLink>
            </li>
          )}
          {permissions.od === "1" && (
            <li>
              <NavLink to="/odlist" onClick={handleLinkClick}>
                <FaFileAlt className="icon" /><span>OD</span>
              </NavLink>
            </li>
          )}
          {permissions.employee === "1" && (
            <li>
              <NavLink to="/settings" onClick={handleLinkClick}>
                <FaBoxes className="icon" /><span>Management Privileges</span>
              </NavLink>
            </li>
          )}
          {/* Reports dropdown (single caret only) */}
          <li className={`sidebar-item-dropdown ${reportsOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleReports}
              aria-expanded={reportsOpen}
              aria-controls="reports-submenu"
            >
              <div className="left">
                <FaMoneyCheckAlt className="icon" />
                <span>Reports</span>
              </div>
              <div className="caret">
                {reportsOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </button>

            <ul id="reports-submenu" className="submenu" aria-hidden={!reportsOpen}>

              {permissions.salary_sf === "1" && (
                <li>
                  <NavLink to="/salary" onClick={handleLinkClick} className="submenu-link">
                    <FaMoneyCheckAlt className="icon-sub" /> <span>Salary (SF)</span>
                  </NavLink>
                </li>
              )}
              {permissions.salary_aided === "1" && (
                <li>
                  <NavLink to="/salaryaided" onClick={handleLinkClick} className="submenu-link">
                    <FaMoneyBillWave className="icon-sub" /> <span>Salary (Aided)</span>
                  </NavLink>
                </li>
              )}
            </ul>
          </li>
        </ul>
      </aside>
    </>
  );
};

export default Sidebar;
